import { useState, useRef, useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation } from "swiper";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import { AppContext } from "../../scripts/context";
import toast from "react-hot-toast";

export default function NFTSlider() {
  const { state, nftItems, setState } = useContext(AppContext);
  const [swiper, navigationPrevRef, navigationNextRef] = [
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  const [activeSlide, setActiveSlide] = useState(
    nftItems[nftItems.length > 2 ? 1 : 0].tokenID
  );

  const approveNFT = async (item) => {
    const {
      contracts: {
        nft: { contract },
      },
    } = state;

    const result = await contract.approve(
      process.env.REACT_APP_STAKING_CONTRACT,
      item.tokenID.toString()
    );

    toast.promise(
      result.wait().then(() => {
        setState({
          contracts: {
            ...state.contracts,
            nft: {
              ...state.contracts.nft,
              data: {
                ...state.contracts.nft.data,
                seletedNFT: item,
              },
            },
          },
        });
      }),
      {
        loading: "Loading...",
        success: "NFT approved",
        error: (error) => error.message,
      }
    );
  };

  return (
    <>
      <Swiper
        initialSlide={nftItems.length > 2 ? 1 : 0}
        ref={swiper}
        pagination={{ clickable: true }}
        modules={[Navigation, EffectCoverflow]}
        className="mySwiper"
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={"auto"}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 0,
          modifier: 1,
          slideShadows: false,
        }}
        navigation={{
          prevEl: navigationPrevRef.current || null,
          nextEl: navigationNextRef.current || null,
        }}
        onInit={(swiper) => {
          swiper.params.navigation.prevEl = navigationPrevRef.current;
          swiper.params.navigation.nextEl = navigationNextRef.current;
          swiper.navigation.init();
          swiper.navigation.update();
        }}
        onSlideChange={(data) => {
          setActiveSlide(
            nftItems[data.activeIndex].tokenID
          );
        }}
      >
        {nftItems.map((item, index) => {
          return (
            <SwiperSlide
              key={index}
              onClick={() => {
                approveNFT(item);
              }}
              className="cursor-pointer"
            >
              <img
                src={item.url}
                style={{
                  userSelect: "none",
                  minWidth: "129.7px",
                  minHeight: "170.74px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  opacity: "0.8",
                  transition: "all 0.3s",
                  cursor: "pointer",
                  ...(activeSlide === item.tokenID
                    ? {
                        transform: "scale(1.2)",
                        filter:
                          "drop-shadow(-5px 18px 13px rgba(80, 80, 80, 0.42))",
                        opacity: "1",
                      }
                    : {}),
                }}
                alt={item.url}
              />
              {activeSlide === item.tokenID && (
                <p className="active-slide-name">{item.name || `Bullit Man #${item.tokenID}`}</p>
              )}
            </SwiperSlide>
          )
        })}
        <div className="arrows-action">
          <div ref={navigationNextRef}>{"<"}</div>
          <div ref={navigationPrevRef}>{">"}</div>
        </div>
      </Swiper>
    </>
  );
}
